<script setup>
import SupplierBrandGrid from '@/components/registry/SupplierBrandGrid.vue'
</script>
<template>
  <supplier-brand-grid />
</template>
